import React from "react";
import { Container } from "@crehana/ui";
import { LearnAcademyPanelDesktopSkeleton } from "./layout/desktop";
import { LearnAcademyPanelMobileSkeleton } from "./layout/mobile";
import { jsx as _jsx } from "react/jsx-runtime";
var DynamicSkeleton = function DynamicSkeleton(_ref) {
  var isMobile = _ref.isMobile,
    isDark = _ref.isDark,
    containerFullWidth = _ref.containerFullWidth,
    containerType = _ref.containerType;
  return /*#__PURE__*/_jsx(Container, {
    type: containerType,
    full: containerFullWidth,
    children: isMobile ? /*#__PURE__*/_jsx(LearnAcademyPanelMobileSkeleton, {
      isDark: isDark
    }) : /*#__PURE__*/_jsx(LearnAcademyPanelDesktopSkeleton, {
      isDark: isDark
    })
  });
};
export default DynamicSkeleton;